import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import axios from 'axios';
import { HelmetProvider } from 'react-helmet-async';
import { AudioProvider } from './contexts/AudioContext';
import { NowPlayingProvider } from './contexts/NowPlayingContext';
import { PlaybackSessionProvider } from './contexts/PlaybackSessionContext';
import { QueueProvider } from './contexts/QueueContext';
import { ShopProvider } from './contexts/ShopContext';
import { AuthProvider } from './contexts/AuthContext';
import { SearchProvider } from './contexts/SearchContext';
import MissionChecker from './components/MissionChecker';
import CookieConsentBanner from './components/CookieConsentBanner';
import AnalyticsTracker from './components/AnalyticsTracker';
import DiscoveryActionBridge from './components/DiscoveryActionBridge';
import GlobalMediaProgressCapture from './components/GlobalMediaProgressCapture';
import GlobalPlaybackSessionBridge from './components/GlobalPlaybackSessionBridge';
import GlobalReadingProgressCapture from './components/GlobalReadingProgressCapture';
import GlobalResumeSync from './components/GlobalResumeSync';
import GlobalResumeNotice from './components/GlobalResumeNotice';
import ListeningHistoryBridge from './components/ListeningHistoryBridge';
import NowPlayingDiscovery from './components/NowPlayingDiscovery';
import PersistentVideoMiniPlayer from './components/PersistentVideoMiniPlayer';
import UpNextDrawer from './components/UpNextDrawer';
import ExploreSearchEntry from './components/search/ExploreSearchEntry';
import UniversalSearchModal from './components/search/UniversalSearchModal';
import AppRouter from './app/AppRouter';
import useSmoothScroll from './app/useSmoothScroll';
import '@/App.css';

axios.defaults.withCredentials = true;

function AppShell() {
  useSmoothScroll();

  return (
    <div className="App min-h-screen bg-background text-foreground noise-texture">
      <BrowserRouter>
        <SearchProvider>
          <AnalyticsTracker />
          <MissionChecker />
          <DiscoveryActionBridge />
          <GlobalMediaProgressCapture />
          <GlobalPlaybackSessionBridge />
          <GlobalReadingProgressCapture />
          <GlobalResumeSync />
          <GlobalResumeNotice />
          <ListeningHistoryBridge />
          <AppRouter />
          <ExploreSearchEntry />
          <PersistentVideoMiniPlayer />
          <NowPlayingDiscovery />
          <UpNextDrawer />
          <UniversalSearchModal />
          <CookieConsentBanner />
        </SearchProvider>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AudioProvider>
        <NowPlayingProvider>
          <PlaybackSessionProvider>
            <QueueProvider>
              <ShopProvider>
                <AuthProvider>
                  <AppShell />
                </AuthProvider>
              </ShopProvider>
            </QueueProvider>
          </PlaybackSessionProvider>
        </NowPlayingProvider>
      </AudioProvider>
    </HelmetProvider>
  );
}

export default App;
